import type { SxProps, Theme } from "@mui/material";

// ─── Job type design tokens ───────────────────────────────────────────────────

export const JOB_TYPE_DESIGN: Record<string, { primary: string; bg: string; border: string; text: string; gradient: string }> = {
  BookingReconciliation: {
    primary: "#7c3aed",
    bg:      "rgba(124,58,237,0.06)",
    border:  "rgba(124,58,237,0.25)",
    text:    "#5b21b6",
    gradient: "linear-gradient(135deg, rgba(124,58,237,0.08) 0%, rgba(124,58,237,0.02) 100%)",
  },
  ContractAssignment: {
    primary: "#0891b2",
    bg:      "rgba(8,145,178,0.06)",
    border:  "rgba(8,145,178,0.25)",
    text:    "#0e7490",
    gradient: "linear-gradient(135deg, rgba(8,145,178,0.08) 0%, rgba(8,145,178,0.02) 100%)",
  },
  EligibleInvoicesReport: {
    primary: "#059669",
    bg:      "rgba(5,150,105,0.06)",
    border:  "rgba(5,150,105,0.25)",
    text:    "#047857",
    gradient: "linear-gradient(135deg, rgba(5,150,105,0.08) 0%, rgba(5,150,105,0.02) 100%)",
  },
  CurrencyRateSync: {
    primary: "#2563eb",
    bg:      "rgba(37,99,235,0.06)",
    border:  "rgba(37,99,235,0.25)",
    text:    "#1e40af",
    gradient: "linear-gradient(135deg, rgba(37,99,235,0.08) 0%, rgba(37,99,235,0.02) 100%)",
  },
};

// ─── Status tokens ────────────────────────────────────────────────────────────

export const STATUS_BG_SUBTLE: Record<string, string> = {
  Queued:    "rgba(237,108,2,0.06)",
  Running:   "rgba(2,136,209,0.06)",
  Completed: "rgba(46,125,50,0.06)",
  Failed:    "rgba(211,47,47,0.06)",
};

// ─── Typography sx constants ──────────────────────────────────────────────────

export const STAT_NUMBER_SX: SxProps<Theme> = {
  fontSize: "28px",
  fontWeight: 700,
  lineHeight: 1,
};

export const SECTION_LABEL_SX: SxProps<Theme> = {
  fontSize: "11px",
  fontWeight: 600,
  letterSpacing: "0.08em",
  textTransform: "uppercase" as const,
  color: "text.secondary",
};

export const MONO_SX: SxProps<Theme> = {
  fontFamily: "monospace",
  fontSize: "12px",
};

export const BODY_SX: SxProps<Theme> = {
  fontSize: "13px",
};

// ─── Chip geometric ───────────────────────────────────────────────────────────

export const CHIP_GEOMETRIC_SX: SxProps<Theme> = {
  borderRadius: "4px",
};

// ─── Shared panel styles ──────────────────────────────────────────────────────

export const PANEL_CARD_SX: SxProps<Theme> = {
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
  overflow: "hidden",
};

export const HEADER_ACCENT_BAR = (color: string, height = 3) => ({
  height,
  bgcolor: color,
  borderRadius: "2px 2px 0 0",
});
